import { Plugin } from "@react-pdf-viewer/core"
import React, { useMemo } from "react"

export interface AttachmentItem {
    name: string
    data: Promise<Uint8Array>
}

export const useAttachmentPlugin = (setAttachments: React.Dispatch<React.SetStateAction<Array<AttachmentItem>>>): Plugin => {
    return useMemo(
        () => ({
            onDocumentLoad: async (props) => {
                const { doc } = props

                try {
                    const attachmentNames = await (doc as any).getAttachments()

                    if (attachmentNames) {
                        const attachmentList: Array<AttachmentItem> = []

                        for (const name in attachmentNames) {
                            if (Object.prototype.hasOwnProperty.call(attachmentNames, name)) {
                                const attachment = attachmentNames[name]
                                attachmentList.push({
                                    name: attachment.filename || name,
                                    data: Promise.resolve(attachment.content),
                                })
                            }
                        }
                        setAttachments(attachmentList)
                    }
                } catch (error) {
                    console.error("Error loading attachments:", error)
                }
            },
        }),
        [setAttachments],
    )
}
